export default __webpack_public_path__ + "static/media/57-min.33f3e9b2.jpg";